import Theme from '@adsk/alloy-react-theme';

export const toolContainerStyle = {
  display: 'flex',
  minHeight: '30px',
  marginBottom: '6px',
};

export const getToolLinkStyle = (hasPermissions) => ({
  textDecoration: 'none',
  textAlign: 'left',
  width: hasPermissions ? '80px' : '100%',
});

export const permissionSelectContainerStyle = {
  width: '230px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexShrink: 0,
};

export const permissionSelectAuxContainerStyle = {
  width: '194px',
  display: 'inline-block',
  verticalAlign: 'top',
};

export const permissionSelectStyle = {
  'height': '30px',
  'minHeight': '30px',
  'padding': 0,
  '> button': {
    visibility: 'visible',
    padding: '1px 2px',
  },
  '> div': {
    'marginLeft': '8px',
    'width': '100%',
    'display': 'flex',
    '> div': {
      'alignSelf': 'center',
      '> div:first-child': {
        'display': 'flex',
        'minWidth': '108px',
        '> div': {
          width: '22px',
        },
      },
      '> div:last-child': {
        marginTop: '0',
        ...Theme.typography.bodySmall,
        color: Theme.colors.charcoal900,
      },
    },
  },
};

export const permissionSelectOverlayStyle = { width: '220px' };

export const selectStyle = {
  'minHeight': '30px',
  '> div': {
    'marginLeft': '8px',
    '> div': {
      ...Theme.typography.bodySmall,
      '> button': {
        ...Theme.typography.bodySmall,
      },
    },
  },
  '> button': {
    padding: '1px 2px',
  },
};

export const permissionsTextStyles = {
  marginLeft: '8px',
};

export const indicatorStyle = {
  'height': '30px',
  'minHeight': '30px',
  'marginLeft': '8px',
  'display': 'flex',
  'alignItems': 'center',
  '> div:first-child': {
    'display': 'flex',
    'minWidth': '108px',
    '> div': {
      width: '22px',
    },
  },
  '> div:last-child': {
    marginTop: '0',
    ...Theme.typography.bodySmall,
    color: Theme.colors.charcoal900,
    textAlign: 'left',
  },
};
